import Services from "../components/home/Services";
import {Container} from "react-bootstrap";
import elements from "../styles/settings/elements.module.scss";

function ServicesPage(){
    return(
        <Container>
            <h1 className={elements.topTitle}>Services</h1>

            <Services/>
        </Container>
    );
}

export default ServicesPage;